'use strict';
/**
 * Accordion (.accordion): toggle via .accordion__toggle, state on .accordion__item (.is-open).
 * Matches _accordion.scss — one open item per .accordion; panel uses [hidden] + max-height animation.
 */
const isMedium = require('../utils/isMedium');

$(() => {
	function isDesktopDisabled($accordion) {
		return $accordion.hasClass('md-accordion-disabled') && isMedium();
	}

	function isMobileStatic($accordion) {
		return $accordion.hasClass('accordion--mobile-static')
			&& !$accordion.closest('.lvz-megamenu-blue-column-item').length
			&& !isMedium();
	}

	function isInteractionDisabled($accordion) {
		return isDesktopDisabled($accordion) || isMobileStatic($accordion);
	}

	function setItemState($item, open) {
		// Toggle is a direct child, or wrapped in a heading (<h3 class="accordion__heading"><button>) for SEO.
		const $toggle = $item.children('.accordion__toggle, .accordion__heading').first().find('.accordion__toggle').addBack('.accordion__toggle').first();
		const $panel = $item.children('.accordion__panel').first();

		if (!$toggle.length || !$panel.length) {
			return;
		}

		$item.toggleClass('is-open', open);
		$toggle.attr('aria-expanded', open ? 'true' : 'false');
		$panel.prop('hidden', !open);
	}

	function syncFromDom($accordion) {
		if (isInteractionDisabled($accordion)) {
			$accordion.find('.accordion__item').each((_, el) => {
				setItemState($(el), true);
			});
			return;
		}

		$accordion.find('.accordion__item').each((_, el) => {
			const $item = $(el);
			setItemState($item, $item.hasClass('is-open'));
		});
	}

	function syncAllAccordions() {
		$('.accordion').each((_, el) => {
			syncFromDom($(el));
		});
	}

	syncAllAccordions();
	$(window).on('resize', syncAllAccordions);

	$(document).on('click', '.accordion__toggle', e => {
		const $toggle = $(e.currentTarget);
		const $item = $toggle.closest('.accordion__item');
		const $accordion = $toggle.closest('.accordion');

		if (!$item.children('.accordion__panel').length) {
			return;
		}

		if (isInteractionDisabled($accordion)) {
			return;
		}

		e.preventDefault();
		const opening = !$item.hasClass('is-open');

		if (opening) {
			// .find() reaches items of nested accordions too, so restrict the
			// "close the others" sweep to items owned by this accordion.
			$accordion
				.find('.accordion__item.is-open')
				.filter((_, el) => $(el).closest('.accordion').is($accordion))
				.not($item)
				.each((_, el) => {
					setItemState($(el), false);
				});
			setItemState($item, true);
		} else {
			setItemState($item, false);
		}
	});

	$(document).on('keydown', '.accordion__toggle', e => {
		const $toggle = $(e.currentTarget);
		const $accordion = $toggle.closest('.accordion');

		if (isInteractionDisabled($accordion)) {
			return;
		}

		if (e.key !== 'Escape') {
			return;
		}
		const $item = $toggle.closest('.accordion__item');
		if ($item.hasClass('is-open')) {
			setItemState($item, false);
			$toggle.trigger('focus');
		}
	});
});
